<template>
 
    <div class="margin-left-right-16">
            <div class="cursor-pointer trigger-hidden-content">
                <img class="margin-top-2" id="" src="../../assets/images/language_u50.svg" width="18"
                    />
            
                    <span v-if="mod.languages" class="cursor-pointer language-text margin-left-5">{{mod.languages.length}}</span>
                <div class="hidden-content hc-left"
                style="width: fit-content"> 
                <div>
                    <ul class="list-unstyled text-left">
                    <template>
        
                    <li v-for="(a,b) in mod.languages" :key="b">
                        <small class="ml-1">{{a}}</small>
                    </li>
                    
                    </template>
                    </ul>
                </div>
                </div>
        </div>
  
    </div>
   
</template>
<script>

export default {
    props:['mod'],
    data() {
        return{
            
        }
        
    },
}
</script>
<style>
.margin-top-2{
    margin-top: 2px;
}
.margin-left-right-16{
    margin-left: 16px;
    margin-right: 16px;
}
.margin-left-5{
    margin-left: 5px;
}
.language-text{
    position: absolute;
    margin-left: 6px;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    top: 1px;
}


</style>



// WEBPACK FOOTER //
// src/components/shopify/ShopifyLanguageIcon.vue